import type { MeetingTemplate } from '@/types/thematic-meetings';

/**
 * How long a meeting held from this template runs: the sum of its agenda's points, which is the
 * only place the answer exists. A template carries no duration of its own, and the server measures
 * a meeting's invitation the same way — from the agenda, never from a figure typed beside it.
 */
export const meetingTemplateDurationMinutes = ({ agendaItems }: MeetingTemplate): number =>
    agendaItems.reduce((total, item) => total + item.durationMinutes, 0);
